import { Action } from '@ngrx/store';
import { LoginSuccess } from './../../../core/models/authorization/login-user.model';

export const ROOT_LOGIN_USER_SUCCESS = '[Root] Login User Success';
export const ROOT_LOGIN_USER_FAIL = '[Root] Login User Fail';
export const ROOT_LOGOUT_USER = '[Root] Logout User';
export const ROOT_LOGOUT_USER_SUCCESS = '[Root] Logout User Success';
export const ROOT_LOGOUT_USER_FAIL = '[Root] Logout User Fail';
export const ROOT_REMEMBER_USER = '[Root] Remember User';
export const ROOT_SET_LANGUAGE = '[Root] Set Language';

export class LoginUserSuccess implements Action {
    readonly type = ROOT_LOGIN_USER_SUCCESS;
    constructor(public payload: LoginSuccess) {}
}
export class LoginUserFail implements Action {
    readonly type = ROOT_LOGIN_USER_FAIL;
    constructor() {}
}

export class LogoutUser implements Action {
    readonly type = ROOT_LOGOUT_USER;
    constructor() {}
}
export class LogoutUserSuccess implements Action {
    readonly type = ROOT_LOGOUT_USER_SUCCESS;
    constructor() {}
}
export class LogoutUserFail implements Action {
    readonly type = ROOT_LOGOUT_USER_FAIL;
    constructor() {}
}

export class RememberUser implements Action {
    readonly type = ROOT_REMEMBER_USER;
    constructor(public payload: any) {}
}

export class SetLanguage implements Action {
    readonly type = ROOT_SET_LANGUAGE;
    constructor(public payload: string) {}
}

export type RootAction =
    | LoginUserSuccess
    | LoginUserFail
    | LogoutUser
    | LogoutUserSuccess
    | LogoutUserFail
    | RememberUser
    | SetLanguage;
